module.exports = __webpack_public_path__ + "c9204c0865ba9b7ee2324bcbdb70513e.png";